var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card" },
      [
        _c("div", { staticClass: "card-header" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-theme",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openModal("register", "")
                }
              }
            },
            [_vm._v("Nuevo")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.critery,
                        expression: "critery"
                      }
                    ],
                    staticClass: "form-control col-md-4",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.critery = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "name" } }, [
                      _vm._v("Nombre del producto")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "code" } }, [
                      _vm._v("Código del producto")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    placeholder: "Ingrese el nombre del producto"
                  },
                  domProps: { value: _vm.search },
                  on: {
                    keyup: function($event) {
                      return _vm.fetchData(
                        1,
                        _vm.search,
                        _vm.critery,
                        _vm.checkboxmanual,
                        _vm.datosTienda
                      )
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-theme",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.fetchData(
                          1,
                          _vm.search,
                          _vm.critery,
                          _vm.checkboxmanual,
                          _vm.datosTienda
                        )
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-search" }),
                    _vm._v(" Buscar")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.datosTienda,
                      expression: "datosTienda"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: {
                    id: "exampleRadios1",
                    type: "radio",
                    name: "exampleRadios",
                    value: "1",
                    checked: ""
                  },
                  domProps: { checked: _vm._q(_vm.datosTienda, "1") },
                  on: {
                    change: [
                      function($event) {
                        _vm.datosTienda = "1"
                      },
                      function($event) {
                        return _vm.fetchData(
                          1,
                          _vm.search,
                          _vm.critery,
                          _vm.checkboxmanual,
                          _vm.datosTienda
                        )
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label col md-3",
                    attrs: { for: "exampleRadios1" }
                  },
                  [_vm._v("\n              La Colima H&A\n            ")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.datosTienda,
                      expression: "datosTienda"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: {
                    id: "exampleRadios2",
                    type: "radio",
                    name: "exampleRadios",
                    value: "2"
                  },
                  domProps: { checked: _vm._q(_vm.datosTienda, "2") },
                  on: {
                    change: [
                      function($event) {
                        _vm.datosTienda = "2"
                      },
                      function($event) {
                        return _vm.fetchData(
                          1,
                          _vm.search,
                          _vm.critery,
                          _vm.checkboxmanual,
                          _vm.datosTienda
                        )
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label col md-3",
                    attrs: { for: "exampleRadios2" }
                  },
                  [_vm._v("\n              GÜICHO COLIMA\n            ")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.datosTienda,
                      expression: "datosTienda"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: {
                    id: "exampleRadios3",
                    type: "radio",
                    name: "exampleRadios",
                    value: "3"
                  },
                  domProps: { checked: _vm._q(_vm.datosTienda, "3") },
                  on: {
                    change: [
                      function($event) {
                        _vm.datosTienda = "3"
                      },
                      function($event) {
                        return _vm.fetchData(
                          1,
                          _vm.search,
                          _vm.critery,
                          _vm.checkboxmanual,
                          _vm.datosTienda
                        )
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label col md-3",
                    attrs: { for: "exampleRadios3" }
                  },
                  [_vm._v("\n              DIOBER\n            ")]
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-control custom-checkbox mb-3" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checkboxmanual,
                        expression: "checkboxmanual"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "customControlValidation1",
                      type: "checkbox",
                      required: ""
                    },
                    domProps: {
                      checked: Array.isArray(_vm.checkboxmanual)
                        ? _vm._i(_vm.checkboxmanual, null) > -1
                        : _vm.checkboxmanual
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.checkboxmanual,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.checkboxmanual = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checkboxmanual = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checkboxmanual = $$c
                          }
                        },
                        function($event) {
                          return _vm.fetchData(
                            1,
                            _vm.search,
                            _vm.critery,
                            _vm.checkboxmanual,
                            _vm.datosTienda
                          )
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.checkboxmanual === false
                    ? _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customControlValidation1" }
                        },
                        [
                          _vm._v(
                            "\n              Mostrar datos inactivos\n            "
                          )
                        ]
                      )
                    : _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customControlValidation1" }
                        },
                        [
                          _vm._v(
                            "\n              Mostrar datos activos\n            "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v("Example invalid feedback text")
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table table-responsive" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.arrayProducts, function(stock) {
                return _c("tr", { key: stock.id }, [
                  _c("td", { domProps: { textContent: _vm._s(stock.name) } }),
                  _vm._v(" "),
                  _c("td", { domProps: { textContent: _vm._s(stock.code) } }),
                  _vm._v(" "),
                  _c("td", { domProps: { textContent: _vm._s(stock.stock) } }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(stock.total_cost) }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(stock.sales_price) }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    stock.state == 1
                      ? _c("span", { staticClass: "btn btn-success btn-sm" }, [
                          _vm._v("Para facturar")
                        ])
                      : stock.state == 2
                      ? _c("span", { staticClass: "btn btn-info btn-sm" }, [
                          _vm._v("No factura")
                        ])
                      : _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                          _vm._v("Desactivado")
                        ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-group mr-2",
                            attrs: {
                              role: "group",
                              "aria-label": "First group"
                            }
                          },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top-center",
                                    value: "Editar producto",
                                    expression: "'Editar producto'",
                                    modifiers: { "top-center": true }
                                  }
                                ],
                                staticClass: "btn btn-theme",
                                on: {
                                  click: function($event) {
                                    return _vm.openModal("update", stock)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-pencil"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            stock.state == 1
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Desactivar producto",
                                        expression: "'Desactivar producto'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-danger",
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal(
                                          "deactivate",
                                          stock
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-trash"
                                    })
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Activar producto",
                                        expression: "'Activar producto'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-info",
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal("activate", stock)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-check"
                                    })
                                  ]
                                )
                          ]
                        )
                      ]
                    ],
                    2
                  )
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "ul",
                { staticClass: "pagination pagination-primary m-b-0" },
                [
                  _vm.pagination.current_page > 1
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(
                                  _vm.pagination.current_page - 1,
                                  _vm.search,
                                  _vm.critery,
                                  _vm.checkboxmanual,
                                  _vm.datosTienda
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-angle-left"
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pagesNumber, function(page) {
                    return _c(
                      "li",
                      {
                        key: page,
                        staticClass: "page-item",
                        class: [page == _vm.isActived ? "active" : ""]
                      },
                      [
                        _c("a", {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          domProps: { textContent: _vm._s(page) },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changePage(
                                page,
                                _vm.search,
                                _vm.critery,
                                _vm.checkboxmanual,
                                _vm.datosTienda
                              )
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.pagination.current_page < _vm.pagination.last_page
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(
                                  _vm.pagination.current_page + 1,
                                  _vm.search,
                                  _vm.critery,
                                  _vm.checkboxmanual,
                                  _vm.datosTienda
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-angle-right"
                            })
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("sweet-modal", { ref: "activar_modal", attrs: { icon: "info" } }, [
          _vm._v("\n      " + _vm._s(_vm.titleModalActivate) + "\n      "),
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              attrs: { slot: "button", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$refs.activar_modal.close()
                }
              },
              slot: "button"
            },
            [_vm._v("\n        No\n      ")]
          ),
          _vm._v(" "),
          _vm.tipoAccion == 3
            ? _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { slot: "button", type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.deactivateProduct()
                    }
                  },
                  slot: "button"
                },
                [_vm._v("\n        Si\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tipoAccion == 4
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { slot: "button", type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.activateProduct()
                    }
                  },
                  slot: "button"
                },
                [_vm._v("\n        Si\n      ")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "product_modal",
            attrs: {
              title: _vm.titleModal,
              width: "75%",
              length: "75%",
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Nombre")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.name,
                      expression: "name",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "nameInput",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.name.$error },
                  domProps: { value: _vm.name },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.name = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.name.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.name.$error
                  ? _c("div", [
                      !_vm.$v.name.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Código")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.code,
                      expression: "code",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "nameInput",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.code.$error },
                  domProps: { value: _vm.code },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.code.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.code.$error
                  ? _c("div", [
                      !_vm.$v.code.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Existencia")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.stock,
                      expression: "stock",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "nameInput",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.stock.$error },
                  domProps: { value: _vm.stock },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.stock = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.stock.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.stock.$error
                  ? _c("div", [
                      !_vm.$v.stock.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Estado de ingreso")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.state,
                        expression: "state",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.state = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("Seleccione el estado")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v("Para facturar")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v("No factura")
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.$v.state.$error
                  ? _c("div", [
                      !_vm.$v.state.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Precio de costo")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.total_cost,
                      expression: "total_cost",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "nameInput",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.total_cost.$error },
                  domProps: { value: _vm.total_cost },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.total_cost = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.total_cost.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.total_cost.$error
                  ? _c("div", [
                      !_vm.$v.total_cost.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Precio de venta")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.sales_price,
                      expression: "sales_price",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "nameInput",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.sales_price.$error },
                  domProps: { value: _vm.sales_price },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.sales_price = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.sales_price.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.sales_price.$error
                  ? _c("div", [
                      !_vm.$v.sales_price.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Precio de descuento")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.special_price,
                      expression: "special_price",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "nameInput",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.special_price.$error },
                  domProps: { value: _vm.special_price },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.special_price = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.special_price.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.special_price.$error
                  ? _c("div", [
                      !_vm.$v.special_price.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Tienda")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.idplace,
                        expression: "idplace",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.idplace = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("Seleccione la tienda")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.arrayPlaces, function(place) {
                      return _c("option", {
                        key: place.id,
                        domProps: {
                          value: place.id,
                          textContent: _vm._s(place.name)
                        }
                      })
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.$v.state.$error
                  ? _c("div", [
                      !_vm.$v.state.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El campo es requerido\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveProduct()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Guardar")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tipoAccion == 2
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.updateProduct()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Actualizar")]
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Productos")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Productos")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Productos")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", [_vm._v("Existencia")]),
        _vm._v(" "),
        _c("th", [_vm._v("Precio de costo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Precio de venta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78357c40", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78357c40","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/products/Products.vue
// module id = 594
// module chunks = 0